import React, { useEffect } from 'react';

function ArticlePage14() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    return (
      <div className="xContent p-box py-6">
        <div className='xContent-wrapper'>
        <h1 class="title is-font-title-regular has-text-centered has-text-var-blue">В Москве пройдет концерт, посвященный произведениям композитора Жанны Верениновой</h1>
        <div className="content">
        <p>7 ноября в выставочно-концертном зале Центрального дома работников искусств в Москве состоится вечер вокально-камерной музыки «Мне музыка слышна в стихах поэтов». На концерте прозвучат произведения лауреата международных конкурсов композиторов, Жанны Верениновой.</p>
        <p>Гости вечера услышат музыку, написанную на стихи поэтов XIX–XX веков. Композиции исполнят ведущие солисты Московского театра «Новая Опера» им. Е.В. Колобова, лауреаты всероссийских и международных фестивалей Александра Саульская-Шулятьева (меццо-сопрано), Елена Терентьева (сопрано), Вениамин Егоров (тенор), Дмитрий Орлов (бас-баритон). Также в концерте примут участие лауреаты международных конкурсов Константин Мошкин (тенор) и солистка Москонцерта Елена Лопухина (меццо-сопрано). За фортепиано – Олег Серебренников. Ведущая вечера – Оксана Мангова.</p>
        </div>
        </div>
      </div>
    );
  }

  export default ArticlePage14;
